var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"work_index_item"},[_c('p',[_vm._v(_vm._s(_vm.applistname))]),_c('ul',_vm._l((_vm.applist),function(item,index){return _c('router-link',{key:index,staticClass:"work_option",attrs:{"to":item.goto}},[_c('img',{attrs:{"src":item.currentSrc}}),_c('div',[_vm._v(_vm._s(item.name))])])}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }